export default {
  excess: "超額責任",
  security: "保證金",
  fuel_policy: "燃油政策",
  like_for_like: "喜歡又喜歡",
  full_to_full: "滿到滿",
  mileage: "里程:每次租賃 {mileage} 英里",
  unlimited_mileage: "不限里程",
  non_refundable: "不退還",
  free_cancellation_until: "免費取消至 {date}",
  cancellation_with_terms: "取消{0}符合 ",
  t_c_text: "T&Cs",
  two_free_extras: "收藏時可免費獲得兩項額外獎勵",
  glass_tyres_covered: "玻璃和輪​​胎被覆蓋",
  spec_fuel_petrol: "汽油",
  spec_fuel_petrol_diesel: "汽油/柴油",
};